import { Button, Paragraph, Text, theme, Logo, styles as baseStyles } from '@socrait/react';
import { StyleSheet, View, Image, TouchableOpacity, useWindowDimensions } from 'react-native';
import { useNavigate } from 'react-router';
import QRCode from 'react-qr-code';
import { sessionStore } from '~/store/sessionStore';
import { ANDROID_APP_URL, IOS_APP_URL, openAndroidAppStore, openIosAppStore } from '~/constants';

import DeviceUrl from '~/assets/images/device.svg';
import AppleStoreUrl from '~/assets/images/appleStore.svg';
import GooglePlayUrl from '~/assets/images/googlePlay.svg';

export function WelcomePage() {
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const isNarrowScreen = width < 701;
  const setIsSetupSubmitted = sessionStore((store) => store.setIsSetupSubmitted);

  const goHome = () => {
    setIsSetupSubmitted(false);
    navigate('/review');
  };

  return (
    <View style={styles.container}>
      <View style={styles.logoContainer}>
        <Logo height={38} width={38} />
      </View>
      <View style={[styles.pageContent]}>
        <View style={[styles.leftSection, isNarrowScreen && styles.leftSectionNarrow]}>
          <Text style={styles.title}>Almost done!</Text>
          <Paragraph
            textStyle={styles.paragraph}
            text="To use Socrait, install the mobile application for Android and iOS using the following QR codes."
          />
          <Button
            name="OK"
            onPress={goHome}
            variant="secondary"
            fontStyle={baseStyles.boldText}
            containerStyle={isNarrowScreen ? styles.OKbuttonNarrow : styles.OKbutton}
          />
          <View style={styles.qrSection}>
            <View style={styles.qrColumn}>
              <QRCode value={ANDROID_APP_URL} size={150} fgColor={theme.colors.primaryPurple} level="H" />
              <TouchableOpacity onPress={openAndroidAppStore}>
                <Image source={{ uri: GooglePlayUrl }} style={styles.storeButton} />
              </TouchableOpacity>
            </View>

            <View style={styles.qrColumn}>
              <QRCode value={IOS_APP_URL} size={150} fgColor={theme.colors.primaryPurple} level="H" />
              <TouchableOpacity onPress={openIosAppStore}>
                <Image source={{ uri: AppleStoreUrl }} style={styles.storeButton} />
              </TouchableOpacity>
            </View>
          </View>
        </View>

        <View style={[styles.deviceSection, isNarrowScreen && styles.deviceSectionNarrow]}>
          <img src={DeviceUrl} />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: theme.spacing.xlarge,
    position: 'relative',
    padding: theme.spacing.xxlarge,
  },
  logoContainer: {
    position: 'absolute',
    top: theme.spacing.xxlarge,
    left: theme.spacing.xxlarge,
    zIndex: 1,
  },
  pageContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing.xlarge,
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'center',
    margin: 'auto',
  },
  OKbutton: {
    alignSelf: 'flex-start',
    width: 200,
    justifyContent: 'center',
  },
  OKbuttonNarrow: {
    alignSelf: 'center',
    width: '100%',
    justifyContent: 'center',
  },
  leftSection: {
    flex: 1,
    flexShrink: 0,
    maxWidth: 450,
    minWidth: 370,
    gap: theme.spacing.xlarge,
  },
  leftSectionNarrow: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: theme.fontSizes.large,
    fontWeight: theme.fontWeights.bold,
  },
  paragraph: {
    fontSize: theme.fontSizes.small,
    lineHeight: theme.lineHeights.small,
  },
  qrSection: {
    flex: 2,
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing.xxlarge * 2,
    flexWrap: 'nowrap',
  },
  qrColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.xlarge,
  },
  storeButton: {
    width: '100%',
    resizeMode: 'contain',
    aspectRatio: 170 / 50,
  },
  deviceSection: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  deviceSectionNarrow: {
    display: 'none',
  },
});
